"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DqPortal = ({
  children,
  className = "root-portal",
  el = "div"
}) => {
  const [container] = _react.default.useState(document.createElement(el));

  container.classList.add(className);

  _react.default.useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, []);

  return /*#__PURE__*/_reactDom.default.createPortal(children, container);
};

var _default = DqPortal;
exports.default = _default;